(() => {
  const getBlogSearchData = () => {
    const node = document.querySelector('[data-td-blog-search-data]');
    if (!node) {
      return [];
    }

    try {
      return JSON.parse(node.textContent);
    } catch {
      return [];
    }
  };

  const normalizeText = (value) =>
    (value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const escapeHtml = (value) =>
    value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const highlightMatch = (text, query) => {
    if (!query) {
      return escapeHtml(text);
    }

    const lowerText = text.toLowerCase();
    const lowerQuery = query.toLowerCase();
    const index = lowerText.indexOf(lowerQuery);

    if (index === -1) {
      return escapeHtml(text);
    }

    const before = text.slice(0, index);
    const match = text.slice(index, index + query.length);
    const after = text.slice(index + query.length);

    return `${escapeHtml(before)}<mark>${escapeHtml(match)}</mark>${escapeHtml(after)}`;
  };

  if (!customElements.get('td-blog-search')) {
    class TdBlogSearch extends HTMLElement {
      #activeIndex = -1;
      #debounceTimer = null;

      connectedCallback() {
        this.input = this.querySelector('[data-td-blog-search-input]');
        this.results = this.querySelector('[data-td-blog-search-results]');

        if (!this.input || !this.results) {
          return;
        }

        this.input.addEventListener('input', () => this.onInput());
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.input.addEventListener('focus', () => this.onInput());

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.closeResults();
          }
        });
      }

      onInput() {
        window.clearTimeout(this.#debounceTimer);

        this.#debounceTimer = window.setTimeout(() => {
          this.renderResults(this.input.value);
        }, 150);
      }

      getMatches(query) {
        const normalizedQuery = normalizeText(query);

        if (!normalizedQuery.length) {
          return [];
        }

        return getBlogSearchData().filter((item) => {
          const haystack = `${normalizeText(item.title)} ${normalizeText(item.description)}`;
          return haystack.includes(normalizedQuery);
        });
      }

      renderResults(query) {
        const matches = this.getMatches(query);
        this.#activeIndex = -1;

        if (!matches.length) {
          if (!normalizeText(query).length) {
            this.closeResults();
            return;
          }

          this.results.innerHTML = '<p class="td-blog-search__empty" role="status">No matching categories found.</p>';
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          return;
        }

        const list = document.createElement('ul');
        list.className = 'td-blog-search__list';
        list.setAttribute('role', 'listbox');

        matches.forEach((item, index) => {
          const li = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'td-blog-search__result';
          button.setAttribute('role', 'option');
          button.dataset.link = item.link;
          button.innerHTML = highlightMatch(item.title, query.trim());
          button.addEventListener('click', () => this.selectCategory(item.link));
          button.addEventListener('mouseenter', () => {
            this.#activeIndex = index;
            this.syncActiveOption();
          });
          li.appendChild(button);
          list.appendChild(li);
        });

        this.results.innerHTML = '';
        this.results.appendChild(list);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      syncActiveOption() {
        const options = [...this.results.querySelectorAll('[role="option"]')];
        options.forEach((option, index) => {
          option.setAttribute('aria-selected', index === this.#activeIndex ? 'true' : 'false');
        });
      }

      onKeydown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          const options = [...this.results.querySelectorAll('[role="option"]')];

          if (options.length && this.#activeIndex >= 0 && !this.results.hidden) {
            this.selectCategory(options[this.#activeIndex].dataset.link);
          }

          return;
        }

        const options = [...this.results.querySelectorAll('[role="option"]')];

        if (event.key === 'Escape') {
          this.closeResults();
          return;
        }

        if (!options.length || this.results.hidden) {
          return;
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.#activeIndex = (this.#activeIndex + 1) % options.length;
          this.syncActiveOption();
          options[this.#activeIndex].focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.#activeIndex = (this.#activeIndex - 1 + options.length) % options.length;
          this.syncActiveOption();
          options[this.#activeIndex].focus();
        }
      }

      selectCategory(link) {
        if (!link) {
          return;
        }

        window.location.href = link;
      }

      closeResults() {
        this.results.hidden = true;
        this.results.innerHTML = '';
        this.#activeIndex = -1;
        this.input.setAttribute('aria-expanded', 'false');
      }
    }

    customElements.define('td-blog-search', TdBlogSearch);
  }
})();
